import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadMoreSectionDetailArticles } from './../actions.js';
import { LoadMore } from './../../ui/src/component/loadMore';
import { Spinner } from './../../ui/src/component/spinner';
import { StandardArticle } from './../../ui/src/component/article';
import { CsmArticle } from './../../ui/src/component/csmArticle';
import { CsmArticlePanorama } from './../../ui/src/component/csmArticlePanorama';
import { Helmet } from 'react-helmet';
import { getProp } from '../../ui/src/utilities.js';
import { CsmSectionLink } from '../../ui/src/component/csmSectionLink/index.js';
import { SectionName } from '../../ui/src/component/csmSectionLink/csmSectionLink.js';
import Icon from '../../ui/src/component/icon/icon.js';
import { StandardArticleCustom } from '../component/standardArticleCustom/index.js';

class SectionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.isSectionsSubtree = this.isSectionsSubtree.bind(this);
    this.onLoadMore = this.onLoadMore.bind(this);
  }

  onLoadMore() {        
    this.props.dispatch(
      loadMoreSectionDetailArticles(
        this.props.id,
        this.props.articlesNextOffset
      )
    );
  }

  isSectionsSubtree() {        
    const section = this.props.sections.byId[this.props.id];    
    if (section && getProp(section, 'subsections', null)) {
      return true;
    }
    return false;
  }

  render() {
    const sectionObject = this.props.sections.byId[this.props.id];
    if (!sectionObject) {
      return <Spinner show={true} />;
    }

    const section = sectionObject.section;
    const content = sectionObject.content;
    const articles = this.props.articles;
    const articlesNextOffset = this.props.articlesNextOffset;

    let articleTilesContainerStyle = {};
    if (!content) {
      articleTilesContainerStyle['paddingTop'] = 0;
    }

    const name = section.name;

    return (
      <div>
        <Helmet>
          <title>{name}</title>
        </Helmet>
        <CsmArticlePanorama article={{ name: name }} />
        <div className="container">
          {content ? (
            <CsmArticle displayMeta={false} content={content} />
          ) : null}
        </div>

        <Spinner show={this.props.detail.isFetching}>
          <div className="section">
            {articles.length > 0 && !this.props.detail.isFetching ? (
              <div className="container">
                <div className="row">
                  {articles.map(item => {
                    return (
                      <div key={item._id} className="col-sm-6 col-md-3">
                        <StandardArticle article={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}

            {articlesNextOffset !== null ? (
              <div className="text-center section">
                <LoadMore
                  show={articlesNextOffset !== null}
                  onClick={this.onLoadMore}
                />
              </div>
            ) : null}
            <div className="container">            
              {this.props.locationId === null &&
                this.isSectionsSubtree() &&
                sectionObject.subsections.map(subsection => {
                  const articles = getProp(subsection, 'articles', []);                                    
                  if (articles.length === 0) {
                    return null;
                  }

                  return (
                    <div key={subsection.id}>
                      <CsmSectionLink section={subsection}>
                        <h2 className="h1">
                          <SectionName>{subsection.name}</SectionName>{' '}
                          <Icon
                            name="chevron-circle-right"
                            className="icon-md"
                          />
                        </h2>
                      </CsmSectionLink>
                      <div className="row flex-row">
                        {articles.map(item => {
                          return (
                            <div
                              key={item._id}
                              className="flex-col col-xs-12 col-sm-6 col-md-3"
                            >
                              <StandardArticleCustom article={item} />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </Spinner>
      </div>
    );
  }
}

SectionDetail.defaultProps = {
  locationId: null
};

SectionDetail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sections: PropTypes.object.isRequired,
  articles: PropTypes.array.isRequired,
  detail: PropTypes.object.isRequired,
  id: PropTypes.number,
  articlesNextOffset: PropTypes.number,
};

export default connect(state => {
  return {
    sections: state.sections,
    detail: state.sectionDetail,
    articles: state.sectionDetail.articles.articles,
    articlesNextOffset: state.sectionDetail.articles.nextOffset,
  };
})(SectionDetail);



// WEBPACK FOOTER //
// ./src/app/container/sectionDetail.js